/* eslint-disable i18next/no-literal-string */
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';

function ManualLoginUI({
  demoEmail,
  handleManualLogin,
  loading,
  error,
}: {
  demoEmail: string;
  handleManualLogin: () => void;
  loading: boolean;
  error: string;
}) {
  return (
    <Box sx={{ textAlign: 'center', padding: 2 }}>
      <Typography variant="h6" gutterBottom>
        Welcome back to Demo Platform
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ marginBottom: 3 }}
      >
        You were logged out. Click below to sign in as {demoEmail}
      </Typography>

      <Button
        onClick={handleManualLogin}
        fullWidth
        variant="contained"
        disabled={loading}
        sx={{
          marginBottom: 2,
          height: 48,
        }}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          'Sign In to Demo'
        )}
      </Button>

      {error && (
        <Alert severity="error" sx={{ marginTop: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
}

export default ManualLoginUI;
